const FDA_TXT = "*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.";
const W = "Adults only. Do not exceed the recommended dose. Pregnant or nursing women, anyone under 18, and anyone with a medical condition or taking medication should consult a physician before use. Keep out of reach of children. Do not use if safety seal is damaged or missing. Store in a cool, dry place.";
const W_LIVE = "Contains live cultures. Consult your doctor before use if you are immunocompromised or seriously ill.";
const COL_WHY = `People take collagen peptides as part of a skin and beauty routine. Collagen supports skin hydration and elasticity.* ${FDA_TXT}`;
const HYD_WHY = `People use electrolyte drinks during active days. Electrolytes support hydration and normal fluid balance, and B vitamins support normal energy metabolism.* ${FDA_TXT}`;
const HYD_LABEL = (cal, color) => `Supplement Facts
Serving Size: 1 Scoop (5.4g)
Servings Per Container: 30
                                               Amount Per Serving   %DV
Calories                                       ${cal}
Total Carbohydrates                            2 g                  <1%**
Thiamin (as Thiamine HCl)                      0.40 mg              33%
Riboflavin (Vitamin B2)                        0.43 mg              33%
Niacin (Vitamin B3)                            5.20 mg NE           33%
Vitamin B6 (as Pyridoxine HCl)                 0.56 mg              33%
Folate (78 mcg Folic Acid)                     133 mcg DFE          33%
Vitamin B12 (as Methylcobalamin)               0.80 mcg             33%
Pantothenic acid (as D-Calcium Pantothenate)   1.66 mg              33%
Calcium (as Calcium Citrate)                   40 mg                3%
Magnesium (as Magnesium Citrate)               20 mg                5%
Sodium (as Sodium Citrate)                     100 mg               4%
Potassium (as Potassium Citrate)               200 mg               4%
** Percent Daily Value (DV) is based on a 2,000 calorie diet.
Other Ingredients: Polydextrose, Citric acid, Natural & Artificial Flavors, Sucralose, Calcium Silicate, ${color} (for color).`;

export const SINGLE_STORY = "Grandpa Finn spent a lifetime on the water: dawn paddles, salty air, and a simple daily habit he never skipped. He kept it plain: look after the basics, every morning, and be patient. That's the idea behind every Grandpa Finn's bottle.";
export const STORY_NOTE = SINGLE_STORY + " (Grandpa Finn is a fictional character.)";
export const PROP65 = "⚠️ WARNING: Consuming this product can expose you to chemicals including lead, which is known to the State of California to cause cancer and birth defects or other reproductive harm. For more information go to www.P65Warnings.ca.gov/food.";
export const PROP65_IDS = ["moringa"];
export const BONE_D_WARNING = "Take 1 capsule only. Each capsule provides 125 mcg (5,000 IU) vitamin D3, which is above the 4,000 IU daily upper limit for adults. Do not take with other vitamin D supplements. Ask your doctor before use, especially if you take blood-thinning medication (vitamin K2 can affect warfarin).";

const SEAMOSS_LABEL = `Supplement Facts
Serving Size: 2 Capsules
Servings Per Container: 30
                                                         Amount Per Serving   % DV
Organic Irish Moss (Chondrus crispus)(whole plant)       500 mg               **
Organic Bladderwrack (Fucus vesiculosus)(whole plant)    500 mg               **
Organic Burdock (Arctium lappa)(root)                    400 mg               **
BioPerine(R) (Black Pepper Extract) (Piper nigrum)(fruit)  5 mg               **
** Daily Value (DV) not established
Other Ingredients: Pullulan Capsules.
Suggested use: 2 capsules once daily (30 servings, 60 capsules).`;

export const SEA_MOSS_TAGLINE = "Irish sea moss, bladderwrack and burdock root, plus a pinch of black pepper extract.";
export const SEA_MOSS_IODINE = "Sea moss and bladderwrack are seaweeds, and seaweed naturally contains iodine. Iodine amounts in seaweed vary and are not listed on this label. The NIH Office of Dietary Supplements sets the adult upper limit at 1,100 mcg of iodine a day from all sources. If you are pregnant or breastfeeding, take medicines, or already get iodine from other supplements, talk to your doctor before use.";

export const SINGLES = {
  "sea-moss": {
    tagline: SEA_MOSS_TAGLINE,
    sku: "GF-SEAMOSS", claims: ["Sea moss and bladderwrack are traditional sea vegetables, in an easy capsule."],
    labels: [{ name: "Sea Moss (60 caps)", text: SEAMOSS_LABEL }],
    warnings: [W, SEA_MOSS_IODINE],
    why: `People take sea moss as a traditional sea vegetable to add to their daily routine. ${FDA_TXT}`,
  },
  "vitamin-d3": {
    sku: "GF-D3", claims: ["Vitamin D supports normal calcium absorption and healthy bones.*"],
    labels: [{ name: "Vitamin D3 2,000 IU", text: `Supplement Facts
Serving Size: 1 Softgel Capsule
                                   Amount Per Serving   % Daily Value
Vitamin D-3 (as cholecalciferol)   50 mcg (2,000 IU)    250%
Other Ingredients: Softgel (gelatin, glycerin, water), soybean oil, corn oil.
Servings per container: 100. Suggested use: 1 softgel daily.` }],
    warnings: [W, "Contains soybean oil. Also contains corn oil and gelatin (softgel)."],
    why: `People take vitamin D3 because many adults get little sun. Vitamin D supports normal bones, muscles and calcium absorption.* ${FDA_TXT}`,
  },
  "magnesium-glycinate": {
    sku: "GF-MG", claims: ["Magnesium supports normal muscle and nerve function.*"],
    labels: [{ name: "Magnesium Glycinate", text: `Supplement Facts
Serving Size: 3 Capsules
Servings Per Container: 30
                                                 Amount Per Serving   %DV*
Magnesium (from 2,500 mg Magnesium Glycinate)    275 mg               65%
*Percent Daily Values (DV) are based on a 2,000 calorie diet.
Other Ingredients: Hypromellose (capsule), Magnesium Stearate, Silicon Dioxide, Rice Flour.` }],
    warnings: [W],
    why: `People take magnesium to top up a mineral many diets run low on. Magnesium supports normal muscle function, relaxation and energy metabolism.* ${FDA_TXT}`,
  },
  "probiotic-20b": {
    sku: "GF-PRO20", claims: ["Supports digestive health.*", "Supports a balanced gut microbiome.*"], story: true,
    labels: [{ name: "Probiotic 20 Billion (30 caps)", text: `Supplement Facts
Serving Size: 1 Capsule
Servings Per Container: 30
                          Amount Per Serving           %DV**
13 Strain Probiotic       317 mg (20 Billion CFU****)  ***
  L. Acidophilus, L. Salivarius, L. Plantarum, L. Rhamnosus, B. Lactis, B. Bifidum, L. Fermentum, L. Reuteri, B. Longum, L. Gasseri, B. Animalis, L. Paracasei, B. Breve
**The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.
***Daily Value (DV) not established.
****20 Billion Live Colony Forming Units (CFU) at the time of manufacture.
Other Ingredients: Cellulose (vegetable capsule), Brown Rice Flour.` }],
    warnings: [W, W_LIVE],
    why: "People take a probiotic to add live cultures to their daily routine. This one has 13 strains and 20 billion CFU per capsule at the time of manufacture.",
    whyClaim: "Supports digestive health.*",
    studies: [{ text: "The NIH Office of Dietary Supplements explains that probiotic labels often list amounts like 1 billion or 10 billion CFU, that a higher CFU count alone does not mean more benefit, and that effects depend on the specific strains and amount. Our capsule lists 20 billion CFU at manufacture; counts can decline over time. This is a general overview, not a study of our product.", url: "https://ods.od.nih.gov/factsheets/Probiotics-Consumer/" }],
  },
  "probiotic-40b": {
    sku: "GF-PRO40", claims: ["Probiotics support digestive health and a healthy balance of gut flora.*", "FOS is a prebiotic fibre that feeds beneficial gut bacteria.*"],
    labels: [{ name: "Probiotic 40 Billion + Prebiotics", text: `Supplement Facts
Serving Size: 2 Capsules
Servings Per Container: 30
                                           Amount Per Serving        %DV
Proprietary Blend of Probiotic Bacteria:   800 mg (40 Billion CFU)   **
  MAKTREK(R) (Bi-Pass Technology)
  Lactobacillus Acidophilus (La-14)
  Bifidobacterium Lactis (Bl-04)
  Lactobacillus Plantarum (Lp-115)
  Lactobacillus Paracasei (Lpc-37)
Complex Marine Polysaccharide              60 mg                     **
Fructooligosaccharide                      24 mg                     **
** Daily Value (DV) not established.
Other Ingredients: Hypromellose (vegetable capsule), Rice maltodextrin, L-Leucine.` }],
    warnings: [W, W_LIVE],
    why: `People take probiotics with prebiotics to add beneficial bacteria and the fibre they feed on. Probiotics support digestive health and a healthy balance of gut flora.* ${FDA_TXT}`,
  },
  "gut-health": {
    sku: "GF-GUT", claims: ["Inulin is a prebiotic fibre that feeds beneficial gut bacteria.*", "Digestive enzymes support the normal breakdown of food.*"],
    labels: [{ name: "Gut Health (60 caps)", text: `Supplement Facts
Serving Size: 2 Capsules
Servings Per Container: 30
                                                            Amount Per Serving      %DV
Organic Apple Cider Vinegar Powder (fruit)                  1,000 mg                **
Inulin (Helianthus tuberosus) (jerusalem artichoke root)    200 mg                  **
DigeZyme(R)                                                 100 mg                  **
Lactobacillus acidophilus LA85                              10 mg (1 Billion CFU***) **
** Daily Value (DV) not established.
*** 1 Billion Live Colony Forming Units (CFU) at the time of manufacture.
Other Ingredients: HPMC (vegetable capsule), Brown Rice Flour, Magnesium Stearate, Olive Oil, Silicon Dioxide.` }],
    warnings: [W, W_LIVE],
    why: `People take this blend for everyday digestive comfort. Inulin is a prebiotic fibre that feeds beneficial gut bacteria, and digestive enzymes support the normal breakdown of food.* ${FDA_TXT}`,
  },
  moringa: {
    sku: "GF-MORINGA", claims: ["Moringa leaf is a traditional food naturally containing vitamins, minerals and plant compounds.*"],
    labels: [{ name: "Moringa Leaf Capsules", text: `Supplement Facts
Serving Size: 2 Capsules
Servings Per Container: 30
                           Amount Per Serving   % Daily Value
Moringa Oleifera (leaf)    800 mg               **
**Daily Value not established.
Other Ingredients: Hypromellose (vegetable capsule)` }],
    warnings: [W, `California (Prop 65): ${PROP65}`],
    why: `People take moringa as a traditional leafy green that naturally contains vitamins, minerals and plant compounds.* ${FDA_TXT}`,
  },
  "bone-k2": {
    sku: "GF-BONE", alert: BONE_D_WARNING,
    claims: ["Vitamin D and calcium support normal bone health.*", "Vitamin K2 supports normal calcium metabolism.*"],
    labels: [{ name: "Bone & K2 (D3 125 mcg / K2 MK-7 100 mcg / Calcium 210 mg, 60 caps)", text: `Supplement Facts
Serving Size: 1 Veggie Capsule
Servings Per Container: 60
                                               Amount Per Serving   %DV
Vitamin D3 (Cholecalciferol)                   125 mcg              625%
Vitamin K2 (mk-7)(as Menaquinone)              100 mcg              **
Calcium (As Calcium Carbonate)                 210 mg               16%
BioPerine (R) (Black Pepper Fruit Extract)     5 mg                 **
** Daily Value (DV) not established
Other Ingredients: Microcrystalline Cellulose, Hypromellose (vegetable capsule).` }],
    warnings: [W, BONE_D_WARNING],
    why: `People take vitamin D3 with K2 and calcium as part of a bone-health routine. Vitamin D and calcium support normal bones, and vitamin K2 supports normal bone mineralisation.* ${FDA_TXT}`,
  },
  "fruits-veggies": {
    sku: "GF-FV", claims: ["Adds fruit and vegetable powders to your daily routine."],
    labels: [{ name: "Fruits & Veggies (60 caps)", text: `Supplement Facts
Serving Size: 2 Capsules
Servings Per Container: 30
                          Amount Per Serving   %DV**
Fruit & Veggie Blend      600 mg               **
  Apple Fiber Powder (Malus pumila)(fruit), Carrot Powder (whole carrot), Beet Root Powder (Beta vulgaris)(root), Blueberry Powder (fruit), Garlic Powder (bulb), Ginger Powder (root), Raspberry Powder (fruit), Red Bell Pepper Powder (fruit), Strawberry Juice Powder (fruit), Tomato Extract (Lycopersicon esculentum)(fruit)
**Daily Value (DV) not established.
Other Ingredients: Gelatin (capsule), Brown Rice Flour.` }],
    warnings: [W, "Gelatin capsule."],
    why: `People take fruit and vegetable capsules to add fruit and vegetable powders to their routine. ${FDA_TXT}`,
  },
  collagen: {
    sku: "GF-COL", claims: ["Supports healthy skin, hair and nails.*", "Collagen peptides support joint health.*"], story: true,
    labels: [{ name: "Grass-Fed Collagen Peptides", text: `Supplement Facts
Serving Size: 1 Scoop (20g)
Servings Per Container: 14
                                                  Amount Per Serving   %DV
Calories                                          70
Protein                                           18 g
Calcium                                           26 mg                2%
Hydrolyzed Collagen Peptides (from bovine hide)   20 g                 **
** Daily Value not established
Other Ingredients: Bovine hide collagen peptides.
14 servings per tub (20 g scoop).` }],
    warnings: [W, "Bovine (beef hide) source."],
    why: "People add collagen peptides to coffee, smoothies or water as part of a daily routine. Each 20 g scoop gives 20 g hydrolyzed collagen peptides from bovine hide (18 g protein).",
    whyClaim: "Supports healthy skin, hair and nails.*",
    studies: [
      { text: "In a double-blind, placebo-controlled trial, 69 women aged 35-55 took 2.5 g or 5 g of a specific collagen hydrolysate daily for 8 weeks; skin elasticity improved versus placebo, while moisture changes were not statistically significant. Note: those doses are much lower than our 20 g scoop, and the study did not test our product.", url: "https://pubmed.ncbi.nlm.nih.gov/23949208/" },
      { text: "A 2021 review of 19 randomized trials (1,125 adults aged 20-70, 95% women) found hydrolyzed collagen taken for about 90 days improved measures of skin hydration and elasticity versus placebo. Doses and products varied between trials and differ from ours.", url: "https://pubmed.ncbi.nlm.nih.gov/33742704/" },
    ],
  },
  "collagen-chocolate": {
    sku: "GF-COLC", claims: ["Collagen protein supports healthy skin as part of a balanced diet.*"],
    labels: [{ name: "Grass-Fed Collagen Peptides – Chocolate", text: `Supplement Facts
Serving Size: 2 Scoops (27 g)
Servings Per Container: 14
                                                  Amount Per Serving   %DV
Calories                                          90
Total Carbohydrates                               3 g                  1%**
Dietary Fiber                                     2 g                  7%**
Protein                                           18 g
Calcium                                           26 mg                2%
Sodium                                            120 mg               5%
Hydrolyzed Collagen Peptides (from bovine hide)   20 g                 ***
** Percent Daily Values are based on a 2,000 calorie diet.
*** Daily Value not established.
Other Ingredients: Cocoa powder, Acacia Powder, Natural Flavor, Sodium Chloride, Xanthan Gum, Stevia Extract Powder (Reb A), Silica.
14 servings per tub (2 scoops, 27 g).` }],
    warnings: [W, "Bovine (beef hide) source. Contains cocoa."],
    why: COL_WHY,
  },
  "collagen-strips": {
    sku: "GF-STRIP", claims: ["Vitamin E is an antioxidant that helps protect cells from oxidative stress.*"],
    labels: [{ name: "Beauty + Collagen Strips", text: `Supplement Facts
Serving Size: 1 Oral Strip (265 mg)
Servings Per Container: 30
                                    Amount Per Serving   %DV
Vitamin E (DL-alpha-Tocopherol)     6 mg                 40%
Collagen Peptide                    100 mg               †
† Daily Value (DV) not established.
Other Ingredients: Pullulan, Cellulose, Mango Flavor, Malic Acid, Pectin, Monk Fruit Extract, Lecithin, Steviol Glycosides.` }],
    warnings: [W, "Contains lecithin (source not stated on label)."],
    why: `People use these strips as a convenient beauty-routine add-on. Vitamin E is an antioxidant that helps protect cells from oxidative stress.* ${FDA_TXT}`,
  },
  "hair-skin-nails": {
    sku: "GF-HSN", claims: ["Biotin supports healthy hair, skin and nails.*"],
    labels: [{ name: "Hair, Skin & Nails Gummies (60)", text: `Supplement Facts
Serving Size: 2 Gummies
Servings Per Container: 30
LEFT                                           Amount Per Serving   %DV
Calories                                       15
Total Carbohydrate                             4 g                  1%**
  Total Sugars                                 4 g                  ***
    Includes 4 g Added Sugars                                       8%**
Vitamin A (as retinyl acetate)                 1200 mcg             133%
Vitamin C (as ascorbic acid)                   30 mg                33%
Vitamin D (as cholecalciferol)                 10 mcg               50%
Vitamin E (as dl-Alpha tocopheryl acetate)     18 mg                120%
Vitamin B-6 (as pyridoxine HCl)                2 mg                 118%
RIGHT                                          Amount Per Serving   %DV
Folate (400mcg folic acid)                     670 mcg DFE          167%
Vitamin B-12 (as cyanocobalamin)               8 mcg                333%
Biotin                                         6000 mcg             20,000%
Pantothenic Acid (as calcium d-pantothenate)   10 mg                200%
Iodine (as potassium iodide)                   80 mcg               53%
Zinc (as zinc citrate)                         2.7 mg               25%
Sodium                                         10 mg                <1%
PABA (para-Aminobenzoic Acid)                  25 mg                ***
Collagen (piscine)                             12 mg                ***
Silicon                                        2 mg                 ***
** % Daily Value (%DV) based on a 2,000 calorie diet.
*** Daily Value not established.
Other Ingredients: Glucose syrup, Sugar, Glucose, Pectin, Citric acid, Sodium citrate, Passion fruit flavor, Vegetable oil (contains carnauba wax), Purple carrot juice concentrate.
Contains: Fish (Tilapia), Tree nuts (Coconut).` }],
    warnings: [W, "Contains: Fish (tilapia), Tree nuts (coconut). Provides 1,200 mcg vitamin A (retinyl acetate, 133% DV): pregnant women should not take additional vitamin A without medical advice. Contains 6,000 mcg biotin, which can interfere with some lab tests (including heart and thyroid tests): tell your doctor you take it. Contains 4 g added sugars per serving."],
    why: `People take hair, skin and nails gummies for a tasty daily vitamin routine. Biotin supports normal hair, skin and nails.* ${FDA_TXT}`,
  },
  reds: {
    sku: "GF-REDS", claims: ["Adds fruit and berry powders to your daily routine.", "Probiotics support a healthy balance of gut flora.*"],
    labels: [{ name: "Reds Superfood (120 g)", text: `Supplement Facts
Serving Size: 1 Scoop (4 g)
Servings Per Container: 30
LEFT                      Amount Per Serving   %DV
Calories                  10
Total Carbohydrates       2 g                  1%**
  Dietary Fiber           2 g                  6%**
Polyphenol Blend          2,000 mg             ***
  Beet Root Powder ( (Beta vulgaris)(root), Strawberry Juice Powder (fruit), Hibiscus Powder (flower), Raspberry Powder (fruit), Black Currant Powder (fruit), Acai Juice Powder (fruit), Blueberry Extract (berry), Cranberry Powder (Vaccinium macrocarpon L.)(fruit), Grape Seed Extract (Vitis vinifera)(seed), African Mango Extract (Irvingia gabonensis)(seed), Pomegranate Powder (fruit)
Digestive Blend           700 mg               ***
  Oat Fiber Powder, Inulin (Helianthus tuberosus)(root)
RIGHT                     Amount Per Serving   %DV
9 Strain Probiotic        100 mg (3.2 Billion****)   **
  L. Salivarius, L. Acidophilus, L. Plantarum, L. Rhamnosus, B. Lactis, B. Bifidum, L. Fermentum, L. Reuteri, B. Longum
Metabolic Blend           400 mg               ***
  Cinnamon (Cinnamomum cassia)(bark), Green Tea Powder (leaf), Ginger Powder (root), Turmeric Powder (root), Shilajit Extract (Asphaltum punjabianum)(gum & resin), Bitter Melon Extract (Momordica charantia Linn.)(fruit), Black Pepper Extract (fruit)
** Percent Daily Values (%DV) are based on a 2,000 calorie diet.
*** Daily Value (DV) not established.
**** 3.2 Billion Live Colony Forming Units (CFU) at the time of manufacture.
Other Ingredients: Maltodextrin, Natural Flavors, Citric Acid, Stevia Extract (leaf).` }],
    warnings: [W, "Contains live cultures, green tea, shilajit and bitter melon extract; consult your doctor if you take blood-sugar or other medication."],
    why: `People take reds powders to add fruit and berry powders to their day. ${FDA_TXT}`,
  },
  ashwagandha: {
    sku: "GF-ASH", claims: ["Ashwagandha (KSM-66®) is a traditional Ayurvedic herb.*", "B vitamins support normal energy metabolism.*"],
    labels: [{ name: "Ashwagandha Plus (60 caps)", text: `Supplement Facts
Serving Size: 2 Capsules
Servings Per Container: 30
                                                                     Amount Per Serving   %DV
Vitamin D3 (as Cholecalciferol)                                      20 mcg               100%
Vitamin B6 (as Pyridoxine Hydrochloride)                             2.5 mg               147%
Vitamin B12 (as Methylcobalamin 1%)                                  25 mcg               1042%
KSM-66(R) Ashwagandha Extract (standardized to 5% Withanolides)      600 mg               **
L-Arginine                                                           300 mg               **
Maca Root Powder (Lepidium meyenii) (root)                           150 mg               **
Panax Ginseng Powder (root)                                          100 mg               **
Shatavari Powder (Asparagus racemosus) (root)                        50 mg                **
** Daily Value (DV) not established.
Other Ingredients: HPMC (vegetable capsule)` }],
    warnings: [W, "Do not use if pregnant or nursing. Consult your doctor if you have a thyroid, liver or autoimmune condition, or take medication (including thyroid, sedative or blood-pressure medication). Contains Panax ginseng, maca, L-arginine and shatavari."],
    why: `People take ashwagandha as a traditional Ayurvedic herb. B vitamins support normal energy metabolism.* ${FDA_TXT}`,
  },
  creatine: {
    sku: "GF-CREA", claims: ["Supports muscle strength and power during high-intensity exercise.*", "Creatine supports exercise performance.*"], story: true,
    labels: [{ name: "Creatine Monohydrate (50 servings × 5 g)", text: `Supplement Facts
Serving Size: 1 Scoop (5.6g)
Servings Per Container: 50
                          Amount Per Serving   %DV
Creatine Monohydrate      5,000 mg             **
**Daily Value not established.` }],
    warnings: [W],
    why: "People take creatine alongside their training. Each 5.6 g scoop gives 5,000 mg creatine monohydrate.",
    whyClaim: "Creatine supports exercise performance.*",
    studies: [{ text: "The International Society of Sports Nutrition's 2017 position stand (a review of research in healthy people and athletes) says creatine supplementation raises muscle creatine and is linked to better high-intensity exercise performance. It describes loading with 5 g creatine monohydrate four times daily for 5-7 days, then 3-5 g/day to maintain stores, which is comparable to one 5 g scoop. This review did not test our product.", url: "https://pubmed.ncbi.nlm.nih.gov/28615996/" }],
  },
  "hydration-lychee": {
    sku: "GF-HYD-LY", claims: ["Electrolytes (sodium and potassium) support hydration and normal fluid balance.*"],
    labels: [{ name: "Hydration Powder – Lychee (162 g)", text: HYD_LABEL("10 kcal", "Beet Juice Powder") }],
    warnings: [W, "Do not exceed 5 scoops in 24 hours."], why: HYD_WHY,
  },
  "hydration-peach-mango": {
    sku: "GF-HYD-PM", claims: ["Electrolytes support hydration.*"],
    labels: [{ name: "Hydration Powder – Peach Mango", text: HYD_LABEL("10 kcal", "Beta Carotene") }],
    warnings: [W], why: HYD_WHY,
  },
  "hydration-passion-fruit": {
    sku: "GF-HYD-PF", claims: ["Electrolytes support hydration.*"],
    labels: [{ name: "Hydration Powder – Passion Fruit", text: "Label not yet verified. Full Supplement Facts panel on the product label." }],
    warnings: [W], why: HYD_WHY,
  },
  "hydration-matcha": {
    sku: "GF-HYD-MT", claims: ["Electrolytes support hydration.*"],
    labels: [{ name: "Hydration Powder – Matcha Green Tea", text: HYD_LABEL("10", "Vegetable Juice Powder") }],
    warnings: [W], why: HYD_WHY,
  },
  "creatine-hydration": {
    sku: "GF-CRH", claims: ["Creatine supports muscle strength during high-intensity exercise.*"],
    labels: [{ name: "Creatine Hydration Powder", text: `Supplement Facts
Serving Size: 1 scoop (10 g)
Servings Per Container: 30
                                    Amount Per Serving   %DV
Calories                            22
Magnesium (as Magnesium Malate)     60 mg                14 %
Sodium (as Sea Salt)                1,000 mg             43%
Potassium (as Potassium Chloride)   200 mg               4%
Creatine Monohydrate                5,000 mg             ***
***Daily Value not established.
Other Ingredients: Natural Flavors, Stevia Extract (Leaf), Silicon Dioxide.` }],
    warnings: [W, "Contains 1,000 mg sodium per serving (43% DV); not for anyone on a sodium-restricted diet."],
    why: `People take creatine with electrolytes alongside training. Creatine supports muscle strength and power during short, intense exercise, and electrolytes support normal fluid balance.* ${FDA_TXT}`,
  },
  "garden-grains": {
    sku: "GF-GRAINS", claims: ["Adds grains and greens to your smoothie."],
    labels: [{ name: "Garden Grains Smoothie Greens", text: `SUPPLEMENT FACTS
Serving Size: 2 Teaspoons (About 5 g)
Servings Per Container: 50
LEFT                           Amount Per Serving   % DV
Calories                       20
Total Carbohydrate             2 g                  1%**
  Dietary Fiber                <1 g                 2%**
Protein                        1 g                  2%**
RIGHT                          Amount Per Serving   % DV
Vitamin A (as Beta Carotene)   270 mcg              30%
Calcium                        15 mg                1%
Sodium                         15 mg                1%
Potassium                      50 mg                1%
Great Grains Blend             1.25 g               ***
  Brown Rice Bran Powder, Organic Flax Seed Powder, Barley Malt Powder
Herbal Blend                   1 g                  ***
  Organic Alfalfa Powder (leaf)^, Parsley Powder (leaf), Bee Pollen Powder, Siberian Ginseng (Eleutherococcus senticosus) Powder (root), Aloe Vera Powder (leaf), Astragalus Powder (root), Bilberry Powder (leaf), Ginger Powder (root), Ginkgo Biloba Powder (leaf), Green Tea Powder (leaf), Licorice Powder (root), Milk Thistle Powder (seed), Peppermint Powder (leaf), Royal Jelly Powder, Schisandra Powder (berry), Stevia Extract Powder (leaf)
Sea Vegetable Blend            900 mg               ***
  Spirulina (Arthrospira platensis) Powder†, Chlorella Powder (plant), Sea Whistle (Ascophyllum nodosum) Powder (plant)
Fruit Blend                    785 mg               ***
  Apple Pectin Powder, Pineapple Powder (fruit), Grape Skin Extract, Acerola Juice Powder (berry)
Green Grass Blend              700 mg               ***
  Organic Barley Grass Powder^, Organic Kamut Grass Powder, Organic Oat Grass Powder^, Organic Rye Grass Powder^, Organic Wheat Grass Powder^
Vegetable Blend                265 mg               ***
  Beet Juice Powder (root), Broccoli Powder (florets), Rhubarb Juice Powder (root), Spinach Powder (leaf)
Fructooligosaccharides (FOS)   98 mg                ***
** Percent Daily Values (DV) are based on a 2,000 calorie diet
***Daily Value (DV) not established
Other ingredients: silica.` }],
    warnings: [W, "Contains bee pollen and royal jelly; may not suit people allergic to bee products. Contains: Wheat (wheat grass, kamut). Also contains barley grass, barley malt, rye grass and oat grass: may contain gluten; not suitable for people with coeliac disease or gluten sensitivity. Contains sea whistle (Ascophyllum, a natural iodine source), licorice, ginkgo, Siberian ginseng and green tea: consult your doctor if you have a thyroid condition, high blood pressure, or take blood-thinning or other medication."],
    why: `People add grain and greens powders to smoothies as part of their daily routine. ${FDA_TXT}`,
  },
  "digestive-enzymes": {
    sku: "GF-DENZ", claims: ["Digestive enzymes support the normal breakdown of food.*"],
    labels: [{ name: "Digestive Enzyme Pro Blend", text: `Supplement Facts
Serving Size: 1 Veggie Capsule
Servings Per Container: 60
                      Amount Per Serving   %DV
Makzyme-Pro(TM)       2500 HUT/400mg       **
Enzyme Blend:
  Fungal Protease (from Aspergillus oryzae, Lactobacillus acidophilus, Lactobacillus casei, Lactobacillus plantarum), Bromelain, Papain, Fungal Lipase, Fungal Lactase, Alpha-Galactosidase
** Daily Value (DV) not established
Other Ingredients: Hypromellose (vegetable capsule), Vegetable Magnesium Stearate, Silicon Dioxide, Maltodextrin.` }],
    warnings: [W, "Contains papain and bromelain: do not use if allergic to papaya or pineapple; consult your doctor if you take blood-thinning medication."],
    why: `People take digestive enzymes with meals. Digestive enzymes support the normal breakdown of food.* ${FDA_TXT}`,
  },
  coq10: {
    sku: "GF-COQ10", claims: ["CoQ10 supports cellular energy production.*"],
    labels: [{ name: "CoQ10 Ubiquinone", text: `Supplement Facts
Serving Size: 1 Capsule
Servings Per Container: 30
                               Amount Per Serving   %DV**
Coenzyme Q-10 (Ubiquinone)     200mg                ***
** % Daily Value (%DV) based on a 2,000 calorie diet
*** Daily Value (DV) not established
Other Ingredients: Rice Flour, Hypromellose (vegetable capsule)` }],
    warnings: [W, "Consult your doctor if you take blood-thinning or blood-pressure medication."],
    why: `People take CoQ10 because the body's own levels change with age. CoQ10 supports cellular energy production.* ${FDA_TXT}`,
  },
  "digestive-strips": {
    sku: "GF-DSTR", claims: ["Probiotics support digestive health.*", "Digestive enzymes support the normal breakdown of food.*"],
    labels: [{ name: "Digestive/Gut Health Strips", text: `Supplement Facts
Serving Size: 1 Oral Strip (210 mg)
Serving Per Container: 30
                              Amount Per Serving        %Daily Value
Bacillus Coagulans            50 mg (10 Billion CFU)    †
Digestive Enzymatic Blend
  Protease                    10 mg                     †
  Papain                      15 mg                     †
  Bromelain                   15 mg                     †
†Daily value not established.
Other ingredients: Pullulan, Mannitol, Monk Fruit Extract, Cellulose, Lecithin, Mixed Berry Flavor, Steviol Glycosides.` }],
    warnings: [W, "Contains papain and bromelain: do not use if allergic to papaya or pineapple. Contains live cultures; consult your doctor if immunocompromised."],
    why: `People use these strips with meals. Probiotics support digestive health, and digestive enzymes support the normal breakdown of food.* ${FDA_TXT}`,
  },
  "probiotic-strips": {
    sku: "GF-PSTR", claims: ["Probiotics support a healthy balance of gut flora.*"],
    labels: [{ name: "Probiotic Strips", text: `Supplement Facts
Serving Size: 1 Oral Strip (180 mg)
Servings Per Container: 30
                          Amount Per Serving        %DV
Polydextrose              50 mg                     †
Bifidobacterium lactis    37.5mg (10 Billion CFU)   †
† Daily Value (DV) not established.
Other Ingredients: Pullulan, Cellulose, Mannitol, Mixed berry flavor, Sunflower Lecithin, Monk fruit extract, Erythritol, Medium chain triglycerides, Malic acid, Steviol glycoside.` }],
    warnings: [W, "Contains live cultures; consult your doctor if immunocompromised."],
    why: `People use these strips as a convenient probiotic. Probiotics support a healthy balance of gut flora.* ${FDA_TXT}`,
  },
  "daily-defence": {
    sku: "GF-IMM", claims: ["Vitamins C and E are antioxidants that help protect cells from oxidative stress.*", "Vitamin D and zinc are essential nutrients that support normal body function.*"],
    labels: [{ name: "Daily Defence Complex", text: `Supplement Facts
Serving Size: 2 Capsules
Servings Per Container: 30
                                               Amount Per Serving   %DV
Vitamin C (as ascorbic acid)                   180 mg               200%
Vitamin D3 (as cholecalciferol)                40 mcg               200%
Vitamin E (as d-alpha tocopheryl acetate)      15 mg                100%
Vitamin B6 (as pyridoxal 5'-phosphate)         1.7 mg               100%
Zinc (as zinc citrate)                         11 mg                100%
Elderberry Extract (Sambucus nigra)(fruit)     500 mg               **
Echinacea purpurea Extract (whole plant)       200 mg               **
Citrus Bioflavonoid 50%                        100 mg               **
L-Lysine                                       100 mg               **
** Daily Value (DV) not established.
Other Ingredients: Gelatin (capsule), Brown Rice Flour.` }],
    warnings: [W, "Contains echinacea and elderberry: do not use if allergic to plants in the daisy family or if you have an autoimmune condition, unless your doctor advises. Gelatin capsule."],
    why: `People take this complex to top up key vitamins and minerals. Vitamins C and E are antioxidants that help protect cells from oxidative stress, and vitamin D and zinc support normal body function.* ${FDA_TXT}`,
  },
  "joint-support": {
    sku: "GF-JOINT", claims: ["Glucosamine and MSM support healthy joints.*"],
    labels: [{ name: "Joint Support", text: `Supplement Facts
Serving Size: 2 Capsules
Servings Per Container: 30
                                                                  Amount Per Serving   %DV**
MSM (methylsulfonylmethane)                                       300 mg               ***
GlucosaGreen(R) vegetal glucosamine HCl                           200 mg               ***
Turmeric Powder (root)                                            200 mg               ***
White Willow Bark Extract                                         150 mg               ***
Boswellia serrata Extract (resin) (std. to 65% boswellic acids)   100 mg               ***
Black Pepper Extract (fruit) (std. to 95% piperine)               10 mg                ***
Hyaluronic Acid                                                   10 mg                ***
**The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.
***Daily Value (DV) not established.
Other Ingredients: Gelatin (capsule), Microcrystalline Cellulose (MCC), Magnesium Stearate, Olive Oil, Silicon Dioxide.` }],
    warnings: [W, "Contains white willow bark (a salicylate): do not use if allergic to aspirin, or if you take blood-thinning medication, without your doctor's advice. Glucosamine is vegetal (not shellfish). Gelatin capsule."],
    why: `People take joint blends as part of an active lifestyle. Glucosamine and MSM support healthy joints.* ${FDA_TXT}`,
  },
  "apple-cider-vinegar": {
    sku: "GF-ACV", claims: ["Inulin is a prebiotic fibre that feeds beneficial gut bacteria.*"],
    labels: [{ name: "Apple Cider Vinegar", text: `Per 2 capsules: organic apple cider vinegar powder 1,000 mg, inulin 200 mg, L. acidophilus LA85 1 billion CFU (10 mg), DigeZyme® 100 mg.
60 capsules; 2 capsules daily; 30 servings.
Full Supplement Facts panel on the product label.` }],
    warnings: [W],
    why: `People take this blend for everyday digestive comfort. Inulin is a prebiotic fibre that feeds beneficial gut bacteria, and digestive enzymes support the normal breakdown of food.* ${FDA_TXT}`,
  },
};
export { W, W_LIVE, HYD_LABEL, HYD_WHY };
export const BUNDLE_IDS = ["calm-waters-reset", "deep-ocean-essentials", "sea-moss-sunshine", "low-tide-calm", "coral-glow", "reef-gut-balance", "captains-daily-pack", "kelp-forest-morning-tide", "sea-spray-active", "full-tide-four", "captains-daily-duo", "gut-and-glow", "full-tide-captains-pack", "fish-oil-2-pack", "sea-moss-2-pack"];
